import { MODULE_TABLE } from '@app/app.config'

import _ from 'lodash'

import { SystemModule } from '@login/type'
import React from 'react'

import MyProfile from '@profile/components/MyProfile'
import MyCareTeam from '@profile/components/MyCareTeam'
import MyTherapeutics from '@profile/components/therapeutics/MyTherapeutics'
import AccountSettings from '@profile/components/AccountSettings'
import AppSettings from '@profile/components/AppSettings'
import ContentPage from '@profile/components/ContentPage'
import Progress from '@profile/components/Progress'
import Contact from '@profile/components/contactForm/Main'

interface ComponentProps {
    config: SystemModule[]
}
const selectedModule = MODULE_TABLE.profile
/** The final array of route configurations with their corresponding components */
const Routes = ({ config }: ComponentProps) => {
    const arr: {
            moduleName: string,
            path: string,
            element: React.ReactNode
        }[] = []

    const found = _.find(config, (o) => {
        return o.moduleName === selectedModule.moduleName
    })

    if (found) {
        _.forEach(_.cloneDeep(found.feRoutes), (o) => {
            let element: React.ReactNode | undefined

            // a new variable named route to pass in so we can cater to routes
            // with parameters on them.
            let routeName = ''
            switch (o.route) {
                case selectedModule.routes.myProfile: {
                    element = <MyProfile/>
                    routeName = o.route
                    break
                }

                case selectedModule.routes.myCareteam: {
                    element = <MyCareTeam/>
                    routeName = o.route
                    break
                }

                case selectedModule.routes.myTherapeutics: {
                    element = <MyTherapeutics/>
                    routeName = o.route
                    break
                }

                case selectedModule.routes.accountSettings: {
                    element = <AccountSettings/>
                    routeName = o.route
                    break
                }

                case selectedModule.routes.settings: {
                    element = <AppSettings/>
                    routeName = o.route
                    break
                }

                case selectedModule.routes.content: {
                    element = <ContentPage/>
                    routeName = o.route
                    break
                }

                case selectedModule.routes.myProgress: {
                    element = <Progress/>
                    routeName = `${ o.route }`
                    break
                }

                case selectedModule.routes.contact: {
                    element = <Contact/>
                    routeName = `${ o.route }`
                    break
                }

                default:
                    break
            }

            element && arr.push({
                moduleName: found.moduleName,
                path: routeName,
                element
            })
        })
    }

    return arr
}

export default Routes
